import { FC, useState } from "react";
import type { IchimokuKinkoHyoSettings } from "../../model";
import styles from "./AcceleratorOscillatorInputsTab.module.css";

type InputKey = "tenkanSenPeriod" | "kijunSenPeriod" | "senkouSpanBPeriod";
type InputValues = Record<InputKey, string>;

const FIELDS: { key: InputKey; label: string; min: number; max: number }[] = [
  { key: "tenkanSenPeriod", label: "Tenkan Sen", min: 1, max: 99 },
  { key: "kijunSenPeriod", label: "Kijun Sen", min: 1, max: 200 },
  { key: "senkouSpanBPeriod", label: "Senkou Span B", min: 1, max: 200 },
];

interface Props {
  settings: IchimokuKinkoHyoSettings;
  onChange: (settings: IchimokuKinkoHyoSettings) => void;
}

export const IchimokuKinkoHyoInputsTab: FC<Props> = ({ settings, onChange }) => {
  const [values, setValues] = useState<InputValues>({
    tenkanSenPeriod: String(settings.tenkanSenPeriod),
    kijunSenPeriod: String(settings.kijunSenPeriod),
    senkouSpanBPeriod: String(settings.senkouSpanBPeriod),
  });

  const handleChange = (key: InputKey, value: string) =>
    setValues((prev) => ({ ...prev, [key]: value }));

  const handleBlur = (key: InputKey) => {
    const field = FIELDS.find((f) => f.key === key)!;
    const parsed = parseInt(values[key], 10);
    const clamped = isNaN(parsed) ? settings[key] : Math.min(Math.max(field.min, parsed), field.max);
    setValues((prev) => ({ ...prev, [key]: String(clamped) }));
    onChange({ ...settings, [key]: clamped });
  };

  return (
    <div className={styles.tab}>
      {FIELDS.map(({ key, label, min, max }) => (
        <div key={key} className={styles.row}>
          <span className={styles.label}>{label}</span>
          <input
            type="number"
            className={styles.input}
            min={min}
            max={max}
            value={values[key]}
            onChange={(e) => handleChange(key, e.target.value)}
            onBlur={() => handleBlur(key)}
          />
        </div>
      ))}
    </div>
  );
};
